import { BASE_URL } from '.';
const tokenData: any = localStorage.getItem('token');
const token = tokenData;

export const api_getBanners = async (pageNo?: number, pageSize?: number) => {
	const page_number = pageNo || 1;
	const page_size = pageSize || 10;
	const uri = `${BASE_URL}/banners/?page=${page_number}&offset=${page_size}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`, // Add bearer token
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_addBanner = async (payload: FormData) => {
	const uri = `${BASE_URL}/banners`;
	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				authorization: `Bearer ${token}`,
			},
			body: payload,
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to create the banner',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Banner created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_deleteBanner = async (bannerId: string) => {
	const uri = `${BASE_URL}/banners/${bannerId}`;
	const response = await fetch(uri, {
		headers: {
			authorization: `Bearer ${token}`,
		},
		method: 'DELETE',
	}).then((res) => res.json());
	return response;
};

export const api_updateBanner = async (bannerId: string, payload: FormData) => {
	const uri = `${BASE_URL}/banners/${bannerId}`;

	try {
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				authorization: `Bearer ${token}`,
			},
			body: payload,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};
